import StatusIndicator from './StatusIndicator';

const OrganizationHeader = ({ headerText, className = "" }: { headerText: string, className?: string }) => {
    return (
        <div className={`d-flex align-items-center ${className}`}>
            <div className="fs-5 fw-semibold">{headerText}</div>
            <StatusIndicator className="ms-5" status="Active" color="green" />
        </div>
    );
};

export default OrganizationHeader;
